import { IStatePlayer } from '../../State/reducers/player';
import { MapList, NODES_PER_MAP } from '../../Config/Levels';
import { StateUtils } from '../StateUtils';

export interface IMapProgression {
    mapLastPlayedLevel: number;
    mapLastLevel: number;
    mapLastLevelId: string;
    gameLastLevel: number;
    rewardIndex: number;
    gainedStars: number;
    showProgression: boolean;
    unlockNextLevel: boolean;
    unlockNextMap: boolean;
    returningFromGame: boolean;
    startNodeIndex: number;
}

export class MapProgression {
    public static setProgression(statePlayer: IStatePlayer, levelIndex: number) {
        this.progression = getMapProgression(statePlayer, levelIndex);
    }

    private static instanceCache: MapProgression;
    private static progression: IMapProgression;

    static get instance(): MapProgression {
        if (!this.instanceCache) {
            this.instanceCache = new MapProgression();
        }
        return this.instanceCache;
    }

    static get current() {
        return this.progression;
    }
}

function getMapProgression(statePlayer: IStatePlayer, levelIndex: number): IMapProgression {
    const { gainedStars } = statePlayer;
    const mapLastPlayedLevel = lastPlayedOnMap(statePlayer, levelIndex);
    const mapLastLevel = newestLevelOnMap(statePlayer);
    const returningFromGame = !(levelIndex === 0 || mapLastLevel === 0);
    const showProgression = mapLastPlayedLevel === mapLastLevel - 1 && returningFromGame;

    return {
        mapLastPlayedLevel,
        mapLastLevel,
        mapLastLevelId: StateUtils.getNextLevelIdForMap(statePlayer),
        gameLastLevel: statePlayer.lastLevelIndex,
        rewardIndex: mapLastLevel, // might change
        gainedStars,
        showProgression,
        unlockNextLevel: unlockNextLevel(statePlayer),
        unlockNextMap: unlockNextMap(statePlayer),
        returningFromGame: !(levelIndex === 0 || mapLastLevel === 0),
        startNodeIndex: showProgression ? mapLastPlayedLevel : mapLastLevel,
    };
}

function lastPlayedOnMap(player: IStatePlayer, levelIndex: number): number {
    if (levelIndex !== 0) {
        return levelIndex - MapList.indexOf(player.mapId) * 50;
    }
    return newestLevelOnMap(player);
}

function newestLevelOnMap(player: IStatePlayer): number {
    const playerLevel = StateUtils.getNextLevelIdForMap(player);
    const lastIndex = parseInt(playerLevel.substr(playerLevel.indexOf('-') + 1), 10);
    return lastIndex;
}

function unlockNextMap(player: IStatePlayer): boolean {
    const hasStars = StateUtils.getStarsForLevel(player, NODES_PER_MAP) > 0;
    if (player.lastLevelIndex >= player.unlocked.length * NODES_PER_MAP && hasStars) {
        if (player.unlocked.length < MapList.length) {
            return true;
        }
    }
    return false;
}

function unlockNextLevel(player: IStatePlayer) {
    const nextId = StateUtils.getNextLevelIdForMap(player);
    return !player.mapLevels[nextId];
}
